import { useEffect } from 'react'
import GetStartedContainer from '../components/GetStarted/GetStartedContainer'
import HomeAiMusicDetector from '../components/HomePageModule/AiMusicDetector/HomeAiMusicDectector'
import HomeStereoToSpatial from '../components/HomePageModule/StereoToSpatial/HomeStereoToSpatial'
import PopularProducts from '../components/PopularProducts/PopularProducts'
import './HomePage.css'
import { fetchCompanyConsumption, fetchUser } from '../api'

export const HomePage = () => {
  useEffect(() => {
    fetchCompanyConsumption()
    fetchUser()
  }, [])
  return (
    <div className="homePage">
      <h2>Try now!</h2>
      <div className="start-basics-container">
        <HomeAiMusicDetector id="home-page-module-ai-music-detector" />
        <HomeStereoToSpatial id="home-page-module-stero-to-spatial" />
      </div>

      <h2>Popular Products</h2>
      <PopularProducts />

      <h2>Everything for your API integration</h2>
      <GetStartedContainer></GetStartedContainer>
    </div>
  )
}
